// extracted by mini-css-extract-plugin
export default {"picturePart":"s2Ia5_picturePart","brandPic-v2":"CL82w_brandPic-v2","procuct-content-item-container":"dC3ti_procuct-content-item-container"};